<mat-icon [ngClass]="[status()]" aria-hidden="true"> videocam </mat-icon>
